import { useState } from 'react';

import BookingQuickForm from './BookingQuickForm'
export default function BookingquickPage() {
	
	const [pageReady, setPageReady] = useState(true);
	    const user = {
        id: 1,
        name: 'John Doe',
        address: '123 Main St, City, State 12345'
    };
	return (
		<main id="BookingquickPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <BookingQuickForm user={user} />
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
